module.exports = __webpack_public_path__ + "static/media/pavan.eb109ced.png";